<template>
  <div
    class="additional-field-card"
    :class="{'isNotActive': !item.isActive}"
    :data-qa="dataqa">
    <div class="additional-field-card__title">
      <router-link
        class="additional-field-card__content"
        :data-qa="dataqa + '-content'"
        :to="disabled ? {} : {name: 'editAutomation', params: {org: $route.params.org, id: item.id} }">
        {{ item.title || '-' }}
        <div
          class="additional-field-card__content-chips">
          <sChip
            v-if="item.isLocked"
            :background="'var(--color-error)'"
            class="mr-2"
            :color="'var(--text-color)'"
            :text="$tc('Automation.Locked', 0)"/>
          <sChip
            :background="item.isActive ? 'var(--color-success)' : 'var(--color-disabled)'"
            :color="'var(--text-color)'"
            :text="item.isActive ? $tc('Automation.Active', 0) : $tc('Automation.NotActive', 0)"/>
        </div>
      </router-link>
      <div
        content-class="additional-field-card__menu">
        <sPopover
          :open-delay="300"
          placement="bottom-end"
          trigger="click">
          <sButton
            slot="reference"
            data-qa="btn-authomation-card-menu"
            :disabled="disabled"
            icon="menu"
            small
            type="text"/>
          <div
            class="menu"
            :data-qa="dataqa + '-menu'">
            <MenuItem
              v-for="(menu_item, index) in menuList"
              :key="index"
              :data-qa="`menu-automation-${menu_item.icon}`"
              :disabled="disabled"
              :icon="menu_item.icon"
              :label="menu_item.text"
              @click="menu_item.click"/>
          </div>
        </sPopover>
      </div>
    </div>
    <div class="additional-field-card__row">
      <KeyValue
        v-if="trigger"
        :caption="$t('Automation.When')"
        class="font-size-14"
        :data-qa="dataqa + '-when'"
        line
        :value="$t(`Automation.trigger.${trigger}`)"/>
      <KeyValue
        v-if="conditions"
        :caption="$t('Automation.Condition')"
        class="mt-2 font-size-14"
        :data-qa="dataqa + '-condition'"
        line>
        <TooltipedText
          :line-count="1"
          :value="conditions"/>
      </KeyValue>
      <KeyValue
        v-if="actions"
        :caption="$t('Automation.Then')"
        class="mt-2 font-size-14"
        :data-qa="dataqa + '-actions'"
        line>
        <TooltipedText
          :line-count="1"
          :value="actions"/>
      </KeyValue>
    </div>
  </div>
</template>
<script>
import godModeMixin from 'mixins/godModeMixin'
import MenuItem from 'components/common/MenuItem.vue'
import KeyValue from 'components/common/KeyValue.vue'
import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'

import textFunctions from 'mixins/textFunctions'

export default {
  name: 'automationCard',
  mixins: [ textFunctions, godModeMixin ],
  methods: {
    edit() {
      this.$router.push({name: 'editAutomation', params: {org: this.$route.params.org, id: this.item.id} })
    },
    remove() {
      this.$emit('delete', this.item.id)
    },
  },
  computed: {
    dataqa() {
      return 'automation-card-' + this.item.id
    },
    menuList() {
      let opts =  [
        {
          text: this.$t('Common.Edit'),
          icon: 'edit',
          click: this.edit
        },
      ]
      if (this.$acl.check('isGoodMode')) {
        opts.push(
          {
            text: this.$t('Tenders.History'),
            icon: 'circle-start',
            click: () => this.$router.push({name: 'page-automation-events', query: {automationId: this.item.id, org: this.$route.params.org}})
          })
      }

      if (!this.item.isLocked || this.mixin_isGodMode) {
        opts.push(
          {
            text: this.$t('Purchasing.Remove'),
            icon: 'delete',
            click: this.remove
          })
      }
      return opts
    },
    trigger() {
      const triggerType = this.item?.trigger?.triggerType
      if (!triggerType) {
        return null
      }
      return this.$_convertToCamelCase(triggerType)
    },
    conditions() {
      const that = this
      const getLabel = (i) => {
        if (i.conditionType === 'TENDER_FIELD') {
          return that.$t(`Automation.condition.${i.condidionField}`)
        } else if (i.conditionType === 'ADDITIONAL_FIELD') {
          return that.spr.additionalFields.find(si => si.id === i.condidionField)?.caption || 'ADDITIONALFIELD'
        }
        return i.conditionType
      }
      return this.item?.conditions?.map(i => getLabel(i)).join(', ') || ''
    },
    actions() {
      return this.item?.actions?.map(i => {
        const key = this.$_convertToCamelCase(i.actionType)
        return this.$t('Automation.action.' + key)
      }).join(', ') || ''
    },
  },
  components: {
    MenuItem,
    KeyValue,
    TooltipedText
  },
  props: {
    item: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    spr: {
      type: Object
    }
  },
}
</script>
<style scoped lang="scss">
.additional-field-card {
  background-color: var(--v-main__light_green-base);
  border-color: var(--v-main__light_green-base);
  border-radius: 8px;
  text-align: left;
  padding: 10px 10px 10px 20px;
  &.isNotActive {
    //text-decoration: line-through;
    color: rgba(var(--text-color-rgba), .5);

    /*.additional-field-card__content {
      color: grey !important;
    }*/
  }
  &__content {
    display: grid;
    grid-template-columns: minmax(100px, 1fr) 190px;
    &-chips {
      text-align: right;
    }
  }
  &__title {
    display: grid;
    grid-template-columns: minmax(205px, 1fr) 30px;
  }
   &__row {
    &-info {
      display: grid;
      grid-template-columns: minmax(45px, 68px) 1fr;
    }
   }
  /*&__row-info {
    display: grid;
    grid-template-columns: 30% 30% 30%;
    &-data {
      margin-left: 10px;
      overflow: auto;
      display: flex;
      flex-wrap: wrap;
    }
  }*/
  /*&__content {
    text-align: left;
    color: var(--black-color);
    caret-color: var(--black-color);
    line-height: 24px;
    letter-spacing: 0.01em;
    width: calc(100% - 35px);
    &-name {
      text-align: start;
      padding: 0 0 4px 0;
      color: #000000;
      caret-color: #000000;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      letter-spacing: 0.01em;
      width: calc(100% - 35px);
      line-height: 1.25;
    }
    &-title {
      font-weight: 500;
      font-size: 16px;
      padding-top: 5px;
      padding-bottom: 10px;
    }
    &-label {
      opacity: 0.5;
      font-size: 10px;
      line-height: 12px;
      font-weight: 500;
      padding-top: 15px;
      text-transform: uppercase;
    }
  }*/
}
</style>
